import { createClient, SupabaseClient } from '@supabase/supabase-js';

// Fixed UUID of the placeholder "SERVER_FAULT" player (see migration 033).
// Used as rallies.server_id for server-fault rallies so the NOT NULL + FK
// constraint is satisfied without attributing the fault to a real player.
// The rotation engine ignores any rally where is_server_fault = true.
export const SERVER_FAULT_PLAYER_ID = '00000000-0000-0000-0000-000000000002';

// Custom event for tournament stats refresh
export const TOURNAMENT_STATS_REFRESH_EVENT = 'volleyball_tournament_stats_refresh';

export function emitTournamentStatsRefresh(tournamentId: string) {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(TOURNAMENT_STATS_REFRESH_EVENT, { detail: { tournamentId } }));
  }
}

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Track configuration status
export const supabaseConfigValid = !!(supabaseUrl && supabaseAnonKey);
export const supabaseConfigError = !supabaseUrl
  ? 'VITE_SUPABASE_URL is not configured'
  : !supabaseAnonKey
    ? 'VITE_SUPABASE_ANON_KEY is not configured'
    : null;

// Create client only if config is valid
export const supabase: SupabaseClient = supabaseConfigValid
  ? createClient(supabaseUrl!, supabaseAnonKey!)
  : null as any; // Will be checked before use
